import React from 'react';
export function PainPoints() {
  return <section className="py-16 px-4 bg-white" data-id="element-147">
      <div className="max-w-4xl mx-auto" data-id="element-148">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-magenta mb-12" data-id="element-149">
          😰 ¿TE SUENA ESTA HISTORIA?
        </h2>

        <div className="grid md:grid-cols-2 gap-8 items-center bg-light-pink rounded-3xl p-8 shadow-xl border-4 border-pink-100" data-id="element-150">
          <div className="space-y-6" data-id="element-151">
            <p className="text-lg text-gray-700" data-id="element-152">
              Se acerca el cumpleaños de tu peque y{' '}
              <strong className="text-magenta" data-id="element-153">
                otra vez no sabes por dónde empezar.
              </strong>
            </p>
            <p className="text-lg text-gray-700" data-id="element-154">
              Buscas ideas en Pinterest y todo se ve precioso… pero imposible de
              hacer.
            </p>
            <p className="text-lg text-gray-700" data-id="element-155">
              Llamas a una decoradora y te da un presupuesto de{' '}
              <strong className="text-orange-500" data-id="element-156">
                $200, $300, hasta $500.
              </strong>
            </p>
            <p className="text-lg text-gray-700" data-id="element-157">
              Corres a la tienda, compras lo primero que encuentras y al final
              la fiesta no queda como imaginabas.
            </p>
            <p className="text-xl font-bold text-gray-800" data-id="element-158">
              Y lo peor: tu hijo merece algo especial. Algo único. Algo que
              recuerde para siempre.
            </p>
            <div className="bg-white p-4 rounded-2xl border-l-4 border-pink-400 shadow-sm" data-id="element-159">
              <p className="text-pink-800 italic font-medium" data-id="element-160">
                💔 Ese momento en que ves la cara de decepción de tu pequeño…
                duele más que cualquier presupuesto.
              </p>
            </div>
          </div>

          <div className="relative" data-id="element-161">
            <div className="absolute inset-0 bg-orange-300 rounded-3xl transform rotate-3 scale-105" data-id="element-162"></div>
            <img src="https://cdn.magicpatterns.com/uploads/vCJ4zGkMfyGSHpq7RPXTuH/FOTO_FRUSTADA.png" alt="Madre frustrada organizando fiesta" className="relative z-10 rounded-3xl shadow-lg w-full object-cover border-4 border-white" data-id="element-163" />
          </div>
        </div>

        <div className="mt-12 text-center bg-orange-100 rounded-3xl p-8 border-4 border-orange-300 shadow-lg transform hover:-translate-y-1 transition-transform" data-id="element-164">
          <h3 className="text-2xl md:text-3xl font-bold text-orange-800" data-id="element-165">
            ¿Y si pudieras crear esa fiesta de ensueño tú misma, desde casa, en
            minutos y por una fracción del precio? ✨
          </h3>
        </div>
      </div>
    </section>;
}